import type React from 'react';
import { Button, Sidebar } from 'shared-portal-components-v2';

import type {
  SidebarActionDefinition,
  SidebarSectionDefinition,
  SidebarFooterDefinition,
} from '@/types/AppLayout.types';

export interface SidebarContentProps {
  prefix: string;
  sections: SidebarSectionDefinition[];
  footer?: SidebarFooterDefinition;
  onAction: (action: SidebarActionDefinition) => void;
}

export function SidebarContent({
  prefix,
  sections,
  footer,
  onAction,
}: SidebarContentProps): React.JSX.Element {
  return (
    <div className="flex h-full flex-col">
      <div className="flex-1">
        {sections.map((sectionDefinition, sectionIndex) => (
          <Sidebar.Section
            key={`${prefix}-${String(sectionDefinition.title ?? 'section')}-${String(sectionIndex)}`}
            title={sectionDefinition.title ?? ''}
          >
            {sectionDefinition.items.map((itemDefinition, itemIndex) => {
              const itemKey = `${prefix}-${itemDefinition.key}-${String(itemIndex)}`;

              if (itemDefinition.kind === 'button') {
                return (
                  <div key={itemKey} className="py-1">
                    <Button
                      className="w-full justify-center"
                      variant={itemDefinition.buttonVariant}
                      size={itemDefinition.buttonSize ?? 'md'}
                      onClick={() => {
                        onAction(itemDefinition.onSelect);
                      }}
                    >
                      {itemDefinition.icon}
                      <span className="ml-2">{itemDefinition.label}</span>
                    </Button>
                  </div>
                );
              }

              return (
                <Sidebar.Item
                  key={itemKey}
                  icon={itemDefinition.icon}
                  label={itemDefinition.label}
                  isActive={itemDefinition.isActive === true}
                  onClick={() => {
                    onAction(itemDefinition.onSelect);
                  }}
                />
              );
            })}
          </Sidebar.Section>
        ))}
      </div>

      {footer !== undefined && (
        <div className="mt-auto">
          <div className="bg-primary/5 border border-primary/20 rounded-lg p-3">
            <div className="flex items-center space-x-2 mb-2">
              <span className="text-primary">{footer.icon}</span>
              <span className="text-sm font-medium text-sidebar-foreground">
                {footer.title}
              </span>
            </div>
            <p className="text-xs text-sidebar-foreground/70">{footer.description}</p>
          </div>
          {footer.content !== undefined && (
            <div className="mt-3 flex justify-center">
              {footer.content}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
